import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78ce3cf1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "server_view" }
const _hoisted_2 = { class: "headline" }
const _hoisted_3 = { class: "describe" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "navbar" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_7 = { class: "swiper" }

import InfrastructureView from "./pages/InfrastructureView.vue";
import LiquidCooling from "./pages/LiquidCooling.vue";
import { onMounted, ref, onUnmounted, onActivated, computed, nextTick } from 'vue'
import useSwiper from '@/utils/useSwiper'
import Mitt from "@/utils/mitt";
import routerHash from "@/constant/router_hash";

const MAX_INDEX = 1
const unit = 50 


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerView',
  setup(__props) {

const serviceRef = ref<HTMLDivElement | null>(null)
const RightHeight = ref(0)

const maxHeight = computed(() => currentIndex.value === 0 ? 'none' : `calc(6rem + ${RightHeight.value}px)`)

const { translateX, currentIndex, onTouchStart, onTouchMove, onTouchEnd } = useSwiper(unit, MAX_INDEX)

const onToggle = (index:number) => currentIndex.value = index

const height = (vHeight: number) => RightHeight.value = vHeight

onMounted(() => {
  Mitt.on(routerHash.IDC_LIQUID_COOLING, () => {
    serviceRef.value!.scrollIntoView(true)
    onToggle(0)
  })
    Mitt.on(routerHash.AIGC_INFRASTRUCTURE, () => {
    serviceRef.value!.scrollIntoView(true)
    onToggle(1)
  })
})

onUnmounted(() => {
  Mitt.off(routerHash.IDC_LIQUID_COOLING)
  Mitt.off(routerHash.AIGC_INFRASTRUCTURE)
})

onActivated(() => window.scrollTo({ top: 0 }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('service.SERVICE_DESCRIPTION')), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('service.SERVICE_TITLE')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onToggle(0)))
      }, _toDisplayString(_ctx.$t('service.LIQUID_COOLING_SERVICE')), 1),
      _hoisted_6,
      _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (onToggle(1)))
      }, _toDisplayString(_ctx.$t('service.AIGC_INFRASTRUCTURE')), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", {
        class: "swiper_content",
        onTouchstart: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(onTouchStart) && _unref(onTouchStart)(...args))),
        onTouchmove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(onTouchMove) && _unref(onTouchMove)(...args))),
        onTouchend: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_unref(onTouchEnd) && _unref(onTouchEnd)(...args))),
        style: _normalizeStyle({'transform': `translateX(${_unref(translateX)})`, 
        'max-height': maxHeight.value
        }),
        ref_key: "serviceRef",
        ref: serviceRef
      }, [
        _createVNode(InfrastructureView),
        _createVNode(LiquidCooling, { onHeight: height })
      ], 36)
    ])
  ]))
}
}

})